module.exports = __webpack_public_path__ + "img/79.a782d417.png";